<template>
    <div>
        <section class="site-section" id="section-blog">
            <div class="container pt-5">
                <div class="col-md-12 pb-2">
                    <div class="section-heading text-center">
                        <h2 class="strong">Blogs on <b>Medium</b></h2>
                    </div>
                </div>

                <div  v-for="chunk in productChunks" :key="chunk" class="row justify-content-center pt-2">
                        
                        <div class="col-sm-6 col-lg-6" v-for="item in chunk" :key="item">
                            <center><div class="blog-entry">
                                <img :src="item.thumbnail" alt="Image placeholder" class="img-fluid">
                                <div class="blog-entry-text">
                                    <h3 class="proj-head" style="font-weight: 400;"><a>{{ item.title }}</a></h3>
                                    <!-- <p class="mb-4">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.</p> -->

                                    <div class="meta">
                                        <a style="color: #fff"><span class="icon-calendar pr-1" ></span> &nbsp; {{ (item.pubDate) }}</a>
                                    </div>
                                    <br>
                                    <center><a :href="item.link" target="_blank"><v-btn :color="yellow">Read</v-btn></a></center>
                                </div>
                            </div></center>
                            
                        </div>
                        
                    <!-- <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <a href="#"><img src="images/post_1.jpg" alt="Image placeholder" class="img-fluid"></a>
                            <div class="blog-entry-text">
                                <h3><a href="#">Creative Product Designer From Facebook</a></h3>
                                <p class="mb-4">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.</p>

                                <div class="meta">
                                    <a href="#"><span class="icon-calendar"></span> Aug 7, 2018</a>
                                    <a href="#"><span class="icon-bubble"></span> 5 Comments</a>
                                </div>
                            </div>
                        </div>
                    </div>-->

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import lodash from 'lodash';
    export default {
        name: "blog",
        data: () => ({
            blogs: [],
            yellow: '#FFB20A'
        }),
        computed: {
			productChunks() {
				return lodash.chunk(Object.values(this.blogs), 6);
			}
        },
        created()
		{
			fetch("https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@SohamDave08")
			.then(res => res.json())
			.then(data => {
				console.log(data.items);
                data.items[0]['thumbnail']='https://firebasestorage.googleapis.com/v0/b/soham-dave08.appspot.com/o/b1.png?alt=media&token=792fa264-fd94-489f-b277-158e31601f10';
                data.items[1]['thumbnail']='https://firebasestorage.googleapis.com/v0/b/soham-dave08.appspot.com/o/b2.png?alt=media&token=1cdb08cf-37cf-495b-8f27-8315b0101781';
				this.blogs = data.items;
			});
		},
    }
</script>

<style scoped>

</style>